import React, { useEffect } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import ScrollToTop from "./components/ScrollToTop";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Projects from "./pages/Projects";
import GalleryDetail from "./pages/GalleryDetail";
import About from "./pages/About";
import Contact from "./pages/Contact";
import OpgaverOverview from "./pages/OpgaverOverview";
import OpgaverDetail from "./pages/OpgaverDetail";
import AndreOpgaver from "./pages/AndreOpgaver";
import ServiceDetail from "./pages/ServiceDetail";
import NotFound from "./pages/NotFound";
import Forbidden from "./pages/Forbidden";
import { ContactDrawerProvider } from "./context/ContactDrawerContext";
import ContactDrawer from "./components/ContactDrawer";
import ContactFormSection from "./components/ContactFormSection";

function App() {
  useEffect(() => {
    document.documentElement.lang = "da";
  }, []);

  return (
    <ContactDrawerProvider>
      <div className="flex flex-col min-h-screen bg-brand-sand-50 text-brand-charcoal antialiased">
        <ScrollToTop />
        <Header />
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/om-os" element={<About />} />
            
            {/* Opgaver routes */}
            <Route path="/opgaver" element={<OpgaverOverview />} />
            <Route path="/opgaver/:taskSlug" element={<OpgaverDetail />} />
            <Route path="/andre-opgaver" element={<AndreOpgaver />} />
            <Route path="/vi-tilbyder/:slug" element={<ServiceDetail />} />

            {/* Galleri routes */}
            <Route path="/galleri" element={<Projects />} />
            <Route path="/galleri/:gallerySlug" element={<GalleryDetail />} />
            <Route path="/projekter" element={<Projects />} />

            {/* Legacy redirect aliases from old Drupal URLs */}
            <Route path="/terrase" element={<Navigate to="/opgaver/opbygning-af-terrasse" replace />} />
            <Route path="/indkoersel" element={<Navigate to="/opgaver/ny-indkoersel" replace />} />
            <Route path="/belaegning" element={<Navigate to="/opgaver/belaegningsarbejde" replace />} />
            <Route path="/stoettemur" element={<Navigate to="/opgaver/stoettemur-opbygning" replace />} />
            <Route path="/stoettemure" element={<Navigate to="/opgaver/stoettemur-opbygning" replace />} />

            {/* Contact & system routes */}
            <Route path="/kontakt" element={<Contact />} />
            <Route path="/403" element={<Forbidden />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>
        <ContactFormSection />
        <Footer />
        <ContactDrawer />
      </div>
    </ContactDrawerProvider>
  );
}

export default App;
